module.exports = __webpack_public_path__ + "themify.2c454669bdf3aebf32a1.eot";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/themify-icons/fonts/themify.eot
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.eot
// module chunks = styles